<template>
  <v-card tile :loading="loading">
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>我的分析工具
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="tabIndex">
        <v-tab>我的收藏</v-tab>
        <v-tab>近期使用</v-tab>

        <!-- 我的收藏 -->
        <v-tab-item>
          <v-row justify="end">
            <v-col cols="auto">
              <v-text-field dense rounded label="关键词" single-line v-model="favToolQueryParam.searchValue" hide-details outlined prepend-inner-icon="mdi-magnify" @keydown.native="onFavToolSearchValueKeydown" />
            </v-col>
          </v-row>
          <v-row v-if="favToolPagination.num!=0">
            <v-col v-for="(item,index) in favToolDataList" :key="index" :cols="colWidth">
              <v-hover v-slot:default="{ hover }">
                <tool-item :elevation="hover ? 12 : 2" :item="item"></tool-item>
              </v-hover>
            </v-col>
            <v-col cols="12" v-if="favToolPagination.num>1">
              <v-pagination v-model="favToolPagination.index" :length="favToolPagination.num" :total-visible="favToolPagination.size" @input="onPageFavTool" />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="text-center text-h5 grey--text">
              暂无数据
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- 近期使用 -->
        <v-tab-item>
          <v-row justify="end">
            <v-col cols="auto">
              <v-btn v-for="(item,index) in coder_types" :key="index" class="ml-4" color="primary" :text="item.code!=recentToolQueryParam.type" @click="onQueryRecentTool(item.code)">{{item.name}}</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-text-field dense rounded label="关键词" single-line v-model="recentToolQueryParam.searchValue" hide-details outlined prepend-inner-icon="mdi-magnify" @keydown.native="onRecentToolSearchValueKeydown" />
            </v-col>
          </v-row>
          <v-row v-if="recentToolPagination.num>0">
            <v-col v-for="(item,index) in recentToolDataList" :key="index" :cols="colWidth">
              <v-hover v-slot:default="{ hover }">
                <tool-item :elevation="hover ? 12 : 2" :item="item"></tool-item>
              </v-hover>
            </v-col>
            <v-col cols="12" v-if="recentToolPagination.num>1">
              <v-pagination v-model="recentToolPagination.index" :length="recentToolPagination.num" :total-visible="recentToolPagination.size" @input="onPageRecentTool" />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="text-center text-h5 grey--text">
              暂无数据
            </v-col>
          </v-row>
        </v-tab-item>

      </v-tabs>
    </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable no-console */
import { queryUserFavTool, queryUserRecentTool } from '@/plugins/api';

export default {
  data () {
    return {
      loading: false,
      colWidth: 3,
      tabIndex: -1,

      favToolDataList: [],
      favToolPagination: { index: 1, size: 12, num: 0, total: 0 },
      favToolQueryParam: { searchValue: '' },

      recentToolDataList: [],
      recentToolPagination: { index: 1, size: 12, num: 0, total: 0 },
      recentToolQueryParam: { searchValue: '', type: 0 },
      coder_types: [
        { code: 0, name: '全部' },
        { code: -1, name: '1个月内' },
        { code: -3, name: '3个月内' },
        { code: -6, name: '6个月内' },
        { code: -12, name: '1年内' }
      ]
    }
  },
  watch: {
    '$route' (to) { if (to.path == '/profile/tool/fav') this.init() },
    tabIndex (v) {
      if (v == 0) this.queryFavTool();
      else this.queryRecentTool();
    }
  },
  created () {
    this.init();
  },
  methods: {
    init () {
      this.tabIndex = 0;
    },
    queryFavTool (param) {
      this.loading = true;
      if (!param) param = { ...this.favToolQueryParam, pagination: { index: 1, size: this.favToolPagination.size } };
      queryUserFavTool(param).then(res => {
        this.favToolDataList = res.data || [];
        this.favToolPagination = res.pagination;
      }).finally(() => this.loading = false)
    },
    onPageFavTool () {
      let param = { ...this.favToolQueryParam, pagination: { index: this.favToolPagination.index, size: this.favToolPagination.size } };
      this.queryFavTool(param);
    },
    onFavToolSearchValueKeydown (e) {
      if (e.keyCode == 13) this.queryFavTool();
    },


    queryRecentTool (param) {
      this.loading = true;
      if (!param) param = { ...this.recentToolQueryParam, pagination: { index: 1, size: this.recentToolPagination.size } };
      queryUserRecentTool(param).then(res => {
        this.recentToolDataList = res.data || [];
        this.recentToolPagination = res.pagination;
      }).finally(() => this.loading = false)
    },
    onQueryRecentTool (type) {
      this.recentToolQueryParam.type = type;
      this.queryRecentTool();
    },
    onPageRecentTool () {
      let param = { ...this.recentToolQueryParam, pagination: { index: this.recentToolPagination.index, size: this.recentToolPagination.size } };
      this.queryRecentTool(param);
    },
    onRecentToolSearchValueKeydown (e) {
      if (e.keyCode == 13) this.queryRecentTool();
    }

  },
  components: {
    ToolItem: () => import('@/views/Component/ToolItem.vue')
  }
}
</script>